import { App } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart, RadarChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GraphicComponent,
} from 'echarts/components';
import { Icon } from '@arco-design/web-vue';
import EllipsisTooltip from '@/components/EllipsisTooltip/index.vue';
import ImgPopover from '@/components/common/img-popover.vue';
import ListImgPopover from '@/components/common/list-img-popover.vue';
import Chart from './chart/index.vue';
import Breadcrumb from './breadcrumb/index.vue';
import QsUploader from './uploader/draggable.vue';
import IsRevoked from './IsRevoked.vue';

// 阿里icon的生产管理项目的图标库
const IconFont = Icon.addFromIconFontCn({
  src: 'https://at.alicdn.com/t/c/font_3821947_cthnrkh7gb7.js',
});
// Manually introduce ECharts modules to reduce packing size

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  RadarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GraphicComponent,
]);

export default {
  install(Vue: App) {
    Vue.component('Chart', Chart);
    Vue.component('Breadcrumb', Breadcrumb);
    Vue.component('IconFont', IconFont);
    Vue.component('QsUploader', QsUploader);
    Vue.component('IsRevoked', IsRevoked);
    Vue.component('EllipsisTooltip', EllipsisTooltip);
    Vue.component('ImgPopover', ImgPopover);
    Vue.component('ListImgPopover', ListImgPopover);
  },
};
